import * as contrat from '@/i18n/fr/baux/contrat/contrat';
import * as bailleur from '@/i18n/fr/baux/bailleur/bailleur';
import constatationCharge from '@/i18n/fr/baux/constatationCharge/constatationCharge';
import echeancesAPayer from '@/i18n/fr/baux/echeancesAPayer/echeancesAPayer';
import echeanceARapprocher from '@/i18n/fr/baux/echeanceARapprocher/echeanceARapprocher';
import * as lotPaiement from '@/i18n/fr/baux/lotPaiement/lotPaiement';
import * as depenseBailleur from '@/i18n/fr/baux/depenseBailleur/depenseBailleur';
import listePaiementsSurFacture from '@/i18n/fr/baux/echeancesAPayer/paiementSurFacture';
import LISTE_FACTURE_ACHAT from '@/i18n/fr/baux/factureAchat/factureAchat';
import LISTE_DEMARCHEUR from '@/i18n/fr/baux/demarcheur/demarcheur';
import * as commandeBailleur from '@/i18n/fr/baux/commandeAchat/commandeAchat';

const BAUX = {
  ajoutEditContrat: contrat.ADD_EDIT_CONTRAT,
  listeContrat: contrat.LISTE_CONTRAT,
  listeContratReconductible: contrat.LIST_BAUX_RECONDUCTIBLE,
  listeContratMateriel: contrat.LISTE_CONTRAT_MATERIEL,
  detailContrat: contrat.DETAIL_CONTRAT,
  listeBailleur: bailleur.LISTE_BAILLEUR,
  choixSousTypeBailleur: bailleur.CHOIX_SOUS_TYPE_BAILLEUR,
  addEditBailleur: bailleur.AJOUT_BAILLEUR,
  detailBailleur: bailleur.DETAIL_BAILLEUR,
  ecranNumeriqueByBailleur: bailleur.ECRAN_NUMERIQUE_BY_BAILLEUR,
  listeConstatationCharge: constatationCharge,
  listeEcheancesAPayer: echeancesAPayer,
  listePaiementSurFacture: listePaiementsSurFacture,
  listeEcheanceARapprocher: echeanceARapprocher,
  listeLotPaiement: lotPaiement.LISTE_LOT_PAIEMENT,
  detailLotPaiement: lotPaiement.DETAIL_LOT_PAIEMENT,
  editionCreationDepenseBailleur: depenseBailleur.DEPENSE_BAILLEUR_EDITION_CREATION,
  listeDepenseBailleur: depenseBailleur.LISTE_DEPENSE_BAILLEUR,
  detailDepenseBailleur: depenseBailleur.DETAIL_DEPENSE_BAILLEUR,
  editLotPaiement: lotPaiement.EDIT_LOT_PAIEMENT,
  listeFactureAchat: LISTE_FACTURE_ACHAT,
  ajoutMateriel: contrat.ADD_MATERIEL_CONTRAT,
  listeDemarcheur: LISTE_DEMARCHEUR,
  listeCommandeAchat: commandeBailleur.LISTE_COMMANDE_ACHAT,
  detailCommandeBailleur: commandeBailleur.DETAIL_COMMANDE_ACHAT_BAILLEUR,
  editCommandeAchatBailleur: commandeBailleur.EDITION_COMMANDE_ACHAT_BAILLEUR,
};

export default BAUX;
